// Modules
import { FC } from 'react';

// UI
import { Navbar, NavbarItem, NavbarSection, NavbarSpacer } from 'components/catalyst/navbar';
import { Badge } from 'components/catalyst/badge';
import UserMenu from './UserMenu';
import { MoonIcon, SunIcon, BellIcon } from '@heroicons/react/20/solid';

interface SidebarNavbarProps {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  handleOpenNotificationsModal: () => void;
  unreadCount: number;
  userMenuExtraItems?: Array<{
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    path?: string;
    onClick?: () => void;
  }>;
}

const SidebarNavbar: FC<SidebarNavbarProps> = ({
  isDarkMode,
  toggleDarkMode,
  handleOpenNotificationsModal,
  unreadCount,
  userMenuExtraItems,
}) => {

  return (
    <Navbar>
      <NavbarSpacer />
      <NavbarSection>
        <NavbarItem onClick={handleOpenNotificationsModal} className='relative'>
          <BellIcon />

          {unreadCount > 0 && (
            <Badge color='blue' className='absolute bottom-5 left-6'>
              {unreadCount}
            </Badge>
          )}
        </NavbarItem>

        <NavbarItem onClick={toggleDarkMode}>
          {isDarkMode ? <SunIcon /> : <MoonIcon />}
        </NavbarItem>

        <UserMenu extraItems={userMenuExtraItems} />
      </NavbarSection>
    </Navbar>
  );
};

export default SidebarNavbar;
